import 'babel-polyfill';

const __svg__ = {
  path: '../icons/*.svg',
  name: 'assets/icons/icons.svg'
}


__svg__.filename = 'wp-content/themes/inaf/assets/icons/icons.svg';
import 'svgxuse';
require('./helpers/svgxhr')(__svg__);

import 'framework/App';

import 'modules/accordions';
import 'modules/articles-list';
import 'modules/autoscroll-slider';
import 'modules/button';
import 'modules/flippable';
import 'modules/header';
import 'modules/menu-mobile';
import 'modules/scroll-to';
import 'modules/slider';

App.whenReady( _ => App.Navigation.init() );



// WEBPACK FOOTER //
// ./resources/js/main.js